var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobalFeedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C2.688 0 0 2.688 0 6C0 9.312 2.688 12 6 12C9.312 12 12 9.312 12 6C12 2.688 9.312 0 6 0ZM5.4 10.758C3.03 10.464 1.2 8.448 1.2 6C1.2 5.628 1.248 5.274 1.326 4.926L4.2 7.8V8.4C4.2 9.06 4.74 9.6 5.4 9.6V10.758ZM9.54 9.234C9.384 8.748 8.94 8.4 8.4 8.4H7.8V6.6C7.8 6.27 7.53 6 7.2 6H3.6V4.8H4.8C5.13 4.8 5.4 4.53 5.4 4.2V3H6.6C7.26 3 7.8 2.46 7.8 1.8V1.554C9.558 2.268 10.8 3.99 10.8 6C10.8 7.248 10.32 8.382 9.54 9.234Z",
    fill: "white",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalFeedIcon);
export default __webpack_public_path__ + "static/media/GlobalFeedIcon.c0d3c598dbe1ab29c2517c5a69bcc722.svg";
export { ForwardRef as ReactComponent };